export const getSecondsFromStringTime = (timeValue, timePart) => {
    if (!timeValue || !timePart) {
        return;
    }
    switch (timePart) {
        case 'milliseconds':
            return timeValue / 1000;
        case 'seconds':
            return timeValue;
        case 'minutes':
            return timeValue * 60;
        case 'hours':
            return timeValue * 3600;
        case 'days':
            return timeValue * 86400;
        case 'months':
            return timeValue * 2629800;
        case 'years':
            return timeValue * 31557600;

        default:
            return 0;
    }
};